function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { enterprisePayTypeApi, clientConfigListApi, clientBillStatusApi, billFinanceApi } from '@/api/enterprise';
import { getToken } from '@/utils/auth';
import { uploader } from '@/utils/uploadCloud';
import SettingMer from '@/libs/settingMer';
export default {
  name: '',
  components: {},
  props: {
    statusOption: {
      type: Array
    },
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    var _this = this;
    var checkAmount = function checkAmount(rule, value, callback) {
      if (_this.types == 0 && !value) {
        return callback(new Error(_this.$t('customer.placeholder33')));
      } else if (_this.types == 1 && !value) {
        return callback(new Error(_this.$t('customer.placeholder35')));
      } else {
        callback();
      }
    };
    var checkDateTime = function checkDateTime(rule, value, callback) {
      if (!value) {
        return callback(new Error('请选择付款时间'));
      } else {
        callback();
      }
    };
    var checkType = function checkType(rule, value, callback) {
      if (!value) {
        return callback(new Error('请选择续费类型'));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      labelWidth: 120,
      uploadSize: 2,
      title01: '回款金额(元)',
      title02: '续费结束日期',
      placeholder01: '请输入回款金额',
      paymentOptions: [],
      sourceOptions: [],
      uploadData: {},
      loading: false,
      imageUrl: '',
      myHeaders: {
        authorization: 'Bearer ' + getToken()
      },
      expireTimeOption: {
        disabledDate: function disabledDate(date) {
          return date.getTime() <= Date.now() - 8.64e7;
        }
      },
      types: 0,
      rules: {
        amount: undefined,
        dateTime: '',
        remarks: '',
        cate_id: '',
        // 续费类型
        attach_ids: '',
        bill_cate_id: [],
        // 账目分类
        end_date: '',
        type_id: ''
      },
      rule: {
        amount: [{
          required: true,
          validator: checkAmount,
          trigger: 'blur'
        }],
        dateTime: [{
          required: true,
          validator: checkDateTime,
          trigger: 'change'
        }],
        type: [{
          required: true,
          validator: checkType,
          trigger: 'change'
        }],
        cate_id: [{
          required: true,
          message: '请选择续费类型',
          trigger: 'change'
        }],
        bill_cate_id: [{
          required: true,
          message: '请选择账目分类',
          trigger: 'blur'
        }],
        type_id: {
          required: true,
          message: '请选择支付方式',
          trigger: 'change'
        } // 支付方式
      }
    };
  },
  computed: {
    fileUrl: function fileUrl() {
      return SettingMer.https + "/system/attach/upload";
    }
  },
  watch: {
    config: {
      handler: function handler(nVal) {
        this.rules.bill_cate_id = nVal.path ? nVal.path : [];
        if (nVal.data.renew) {
          this.rules.cate_id = nVal.data.renew.id;
        }
        this.types = nVal.data.types;
        if (JSON.stringify(nVal.data.attachs) !== '[]') {
          this.imageUrl = nVal.data.attachs[0].src;
          this.rules.attach_ids = nVal.data.attachs[0].id;
        }
        this.rules.amount = nVal.data.num;
        this.rules.type_id = nVal.data.type_id;
        this.rules.remarks = nVal.data.mark;
        this.rules.dateTime = this.$moment(nVal.data.date).format('YYYY/MM/DD HH:mm:ss');
        if (nVal.data.end_date == '0000-00-00') {
          this.rules.end_date = '';
        } else {
          this.rules.end_date = nVal.data.end_date;
        }
        if (this.types == 0) {
          this.title01 = '回款金额(元)';
        } else {
          this.title01 = '续费金额(元)';
          this.placeholder01 = '请输入续费金额';
        }
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    handleOpen: function handleOpen() {
      this.dialogVisible = true;
      this.getPaymentMethod();
      this.getClientList();
    },
    // 选择账目分类
    handleChange: function handleChange(val) {},
    // 获取支付方式
    getPaymentMethod: function getPaymentMethod() {
      var _this2 = this;
      var data = {
        status: 1
      };
      enterprisePayTypeApi(data).then(function (res) {
        _this2.paymentOptions = res.data.list;
      });
    },
    // 列表
    getClientList: function getClientList() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var key, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              key = 'renew';
              _context.next = 3;
              return clientConfigListApi({
                key: key
              });
            case 3:
              result = _context.sent;
              _this3.sourceOptions = result.data === undefined ? [] : result.data;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleConfirm: function handleConfirm() {
      var _this4 = this;
      var data = {};
      if (this.rules.bill_cate_id.length > 0) {
        this.rules.bill_cate_id = this.rules.bill_cate_id.pop();
      }
      this.$refs.form.validate(function (valid) {
        if (valid) {
          data = {
            cid: _this4.config.data.cid,
            eid: _this4.config.data.eid,
            types: _this4.config.data.types,
            num: _this4.rules.amount,
            mark: _this4.rules.remarks,
            date: _this4.$moment(_this4.rules.dateTime).format('YYYY-MM-DD HH:mm:ss'),
            end_date: _this4.rules.end_date,
            type_id: _this4.rules.type_id,
            cate_id: _this4.rules.cate_id,
            bill_cate_id: _this4.rules.bill_cate_id,
            attach_ids: _this4.rules.attach_ids
          };
          if (_this4.config.type == 'edit') {
            _this4.clientContractEdit(_this4.config.data.id, data);
          } else {
            ;
            data.status = 1, _this4.clientContractPass(_this4.config.data.id, data);
          }
        }
      });
    },
    // 通过付款与续费
    clientContractPass: function clientContractPass(id, data) {
      var _this5 = this;
      this.loading = true;
      clientBillStatusApi(id, data).then(function (res) {
        _this5.loading = false;
        _this5.handleClose();
        _this5.reset();
        _this5.$emit('isOk');
      }).catch(function (error) {
        _this5.loading = false;
      });
    },
    // 编辑付款与续费
    clientContractEdit: function clientContractEdit(id, data) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return billFinanceApi(id, data);
            case 2:
              _this6.handleClose();
              _this6.reset();
              _this6.$emit('isOk');
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.imageUrl = '';
      if (this.config.edit === 2) {
        this.reset();
      }
      this.reset();
    },
    reset: function reset() {
      this.rules.amount = undefined;
      this.rules.dateTime = '';
      this.rules.end_date = '';
      this.rules.remarks = '';
      this.rules.type = '';
      this.rules.day = undefined;
      this.rules.period = 2;
      this.rules.bill_cate_id = [];
      this.imageUrl = '';
    },
    // 上传文件方法
    uploadServerLog: function uploadServerLog(params) {
      var _this7 = this;
      this.percentShow = true;
      var file = params.file;
      var options = {
        way: 2,
        relation_type: 'bill',
        relation_id: 0,
        eid: 0
      };
      uploader(file, 1, 2, options).then(function (res) {
        // 获取上传文件渲染页面
        if (res.name) {
          _this7.imageUrl = res.url;
          _this7.rules.attach_ids = res.attach_id;
        }
      }).catch(function (err) {
        _this7.percentShow = false;
      });
    }
  }
};